import Chart from 'chart.js/auto'

class ChartClass
{
    #charts;

    constructor(){
        this.#charts = {};
    }

    //Adiciona um grafico a lista de graficos
    addChart(name, chart)
    {
        this.#charts[name] = chart
    }

    //Retorna um objeto de grafico da lista de graficos
    getChart(name)
    {
        return this.#charts[name]
    }

    //limpa as labels e o dataset do grafico
    clearData(name)
    {
        this.getChart(name).data.labels.pop()
        this.getChart(name).data.datasets.forEach((dataset) =>
        {
            dataset.data.pop()
        })
        this.getChart(name).update()
    }

    //Atualiza as labels e o dataset do grafico
    updateData(name, label, data)
    {
        this.clearData(name)
        this.getChart(name).data.labels = label
        this.getChart(name).data.datasets = data
        this.getChart(name).update()
    }

    create(type, name, target, responsive, config={})
    {
        switch (type)
        {
            case 'pie':
                this.addChart(name, this.pie(target, responsive, config))
                break
            case 'horizontalBar':
                this.addChart(name, this.horizontalBar(target, responsive, config))
                break
            case 'bar':
                this.addChart(name, this.bar(target, responsive, config))
                break
        }
    }

    pie(target, responsive=true, config={}) {
        return new Chart(
            document.getElementById(target).getContext('2d'),
            {
                type: 'pie',
                options: {
                    layout: {
                        padding: 5
                    },
                    responsive: responsive,
                    maintainAspectRatio: true,
                    aspectRatio: 2,
                    plugins: {
                        datalabels: {
                            color: config.datalabels && config.datalabels.color ? config.datalabels.color : 'white',
                            font: {
                                weight: 'bold'
                            },
                            formatter: function(value, context)
                            {
                                var total = context.dataset.data.reduce(function(previousValue, currentValue, currentIndex, array)
                                {
                                    return previousValue + currentValue
                                })

                                var percentage = parseFloat((value / total * 100).toFixed(1))

                                return percentage + '%'
                            }
                        },
                        legend: {
                            display: config.legend && config.legend.display != undefined ? config.legend.display : true,
                            position: config.legend && config.legend.position ? config.legend.position : 'right',
                            align: config.legend && config.legend.align ? config.legend.align : 'center',
                            padding: 5,
                            labels: {
                                pointStyle: config.legend && config.legend.labels && config.legend.labels.pointStyle ? config.legend.labels.pointStyle : 'circle',
                                usePointStyle: true,
                                // padding: config.legend && config.legend.labels && config.legend.labels.padding ? config.legend.labels.padding : 25,
                                //fontColor: 'rgb(255, 99, 132)'
                            }
                        }
                    }
                }
            }
        )
    }

    horizontalBar(target, responsive=true, config={}) {
        return this.bar(
            target,
            responsive,
            {
                ...{indexAxis: 'y'},
                ...config
            },
            'bar'
        );
    }

    verticalBar(target, responsive=true, config={}) {
        return this.bar(
            target,
            responsive,
            {
                ...{indexAxis: 'x'},
                ...config
            },
            'bar'
        );
    }

    bar(target, responsive=true, config={}, type='bar') {
        var ctx = document.getElementById(target).getContext('2d')
        return new Chart(ctx, {
            type: type,
            options: {
                indexAxis: config?.indexAxis,
                layout: {
                    padding: {
                        top: 5,
                        right: 5,
                        left: 5,
                        bottom: 5,
                    }
                },
                responsive: responsive,
                maintainAspectRatio: config?.maintainAspectRatio ?? false,
                scales: {
                    x: {
                        stacked: true
                    },
                    y: {
                        stacked: true
                    }
                },
                plugins: {
                    datalabels: {
                        color: config.datalabels && config.datalabels.color ? config.datalabels.color : 'black',
                        anchor: 'end',
                        align: 'end',
                        offset: 1,
                        font: {
                            weight: 'bold'
                        }
                    },
                    legend: {
                        display: config.legend && config.legend.display != undefined ? config.legend.display : true,
                        position: config.legend && config.legend.position ? config.legend.position : 'bottom',
                        padding: config.legend && config.legend.padding ? config.legend.padding : 200
                    }
                }
            }
        })
    }
}

export default new ChartClass()
